module.exports = __webpack_public_path__ + "f7d7902fef6c9c8d910a5249fc5fb746.jpg";